import { logger, EventCategory } from 'utils/logger'
import { loggerSentry } from '@/utils/loggerSentry'

/**
 * How the reporting caller handled the write it is reporting on:
 * 'stamped' — observability only, the write proceeded; 'skipped' — a guard
 * refused the write. The record must say which, or a field investigation
 * reads a blocked wipe as a landed one (and vice versa).
 */
export type WipeWriteOutcome = 'stamped' | 'skipped'

/**
 * One emitter for every page-wipe provenance event. Each canvas→pages
 * writer and the editor Save call this when a payload is wipe-shaped
 * (zero items over a populated page) or cross-page, so a field occurrence
 * of the production page-wipe names its writer and the atom state that
 * produced it. Correlate with the backend `suspicious_page_wipe` audit row
 * via page id + timestamp. Emits to Datadog (logger) and Sentry
 * (loggerSentry) with the same payload.
 */
export const logWipeProvenance = (
  message: string,
  detail: string,
  data: Record<string, unknown>,
  writeOutcome: WipeWriteOutcome = 'stamped',
): void => {
  const outcomeNote =
    writeOutcome === 'skipped'
      ? 'write skipped by guard'
      : 'observability only, write not blocked'
  logger.error({
    message,
    category: EventCategory.ERROR,
    error: new Error(`${detail} (${outcomeNote})`),
    data: { ...data, writeOutcome },
  })
  loggerSentry.error({
    message,
    category: EventCategory.ERROR,
    error: new Error(message),
    data: { ...data, writeOutcome },
  })
}

export default logWipeProvenance
